import { FlexColumn, FlexRow, Link, Placeholder } from '@forecast-it/design-system';
import { CalendarEvent } from './CalendarEvent';
import React, { useEffect, useState } from 'react';
import { trackEvent } from '../../../../../tracking/amplitude/TrackingV2';
export const CalendarEvents = ({ calendarEvents, isEventConverted, renderPlaceholders, isLocked, openModal, showContextMenu, }) => {
    const defaultVisibleEvents = 8;
    const [visibleEvents, setVisibleEvents] = useState(defaultVisibleEvents);
    const visibleCalendarEvents = calendarEvents === null || calendarEvents === void 0 ? void 0 : calendarEvents.slice(0, visibleEvents);
    const numberOfHiddenEvents = (calendarEvents === null || calendarEvents === void 0 ? void 0 : calendarEvents.length) - visibleEvents;
    const showLess = (e) => {
        e.stopPropagation();
        trackEvent('Show Less Events Link', 'Clicked');
        setVisibleEvents(defaultVisibleEvents);
    };
    const showMoreEvents = (e, number) => {
        e.stopPropagation();
        trackEvent('Show More Events Link', 'Clicked', { totalEvents: calendarEvents === null || calendarEvents === void 0 ? void 0 : calendarEvents.length });
        setVisibleEvents(visibleEvents + number);
    };
    useEffect(() => {
        setVisibleEvents(defaultVisibleEvents);
    }, [calendarEvents === null || calendarEvents === void 0 ? void 0 : calendarEvents.length]);
    return (React.createElement(React.Fragment, null,
        React.createElement(FlexColumn, null, (visibleCalendarEvents === null || visibleCalendarEvents === void 0 ? void 0 : visibleCalendarEvents.length) ? (visibleCalendarEvents.map(event => (React.createElement(CalendarEvent, { event: event, isLocked: isLocked, isConverted: isEventConverted(event === null || event === void 0 ? void 0 : event.id), openModal: openModal, showContextMenu: showContextMenu })))) : renderPlaceholders ? (React.createElement(React.Fragment, null, [...Array(4)].map(() => (React.createElement(Placeholder, { height: '52px' }))))) : null),
        numberOfHiddenEvents > 0 && (React.createElement(FlexRow, null,
            React.createElement(Link, { onClick: e => showMoreEvents(e, numberOfHiddenEvents) },
                "Show ",
                numberOfHiddenEvents,
                " more"))),
        visibleEvents > 8 && (React.createElement(FlexRow, null,
            React.createElement(Link, { onClick: e => showLess(e) }, "Show less")))));
};
